// extracted by mini-css-extract-plugin
export default {"root":"ChoiceRow-module__root___FsJna","center":"ChoiceRow-module__center___tPnmp","top":"ChoiceRow-module__top___rIVVv"};